import React, { useState } from "react";
import { MEDIA_URL } from '../../config/constants';
import { useTranslation } from "../../hooks/useTranslation";

const ContactForm = () => {
  const { t } = useTranslation('home');
  const { t: tCommon } = useTranslation('common');
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState({
    submitting: false,
    submitted: false,
    error: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, submitted: false, error: null });

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(process.env.REACT_APP_API_KEY && { "X-API-Key": process.env.REACT_APP_API_KEY }),
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || tCommon('form.error'));
      }

      // Success
      setStatus({ submitting: false, submitted: true, error: null });
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });

      // Reset success message after 5 seconds
      setTimeout(() => {
        setStatus((prev) => ({ ...prev, submitted: false }));
      }, 5000);
    } catch (error) {
      setStatus({
        submitting: false,
        submitted: false,
        error: error.message,
      });
    }
  };

  return (
    <div className="contact-section">
      <div className="contact-content">
        <div className="contact-title">{t('contact.title')}</div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-input">
              <div className="input-wrapper">
                <div className="input-state-layer">
                  <div className="input-content">
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      className="input-text"
                      placeholder={tCommon('form.placeholders.firstName')}
                      required
                    />
                    <div className="input-label">{tCommon('form.firstName')}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-input">
              <div className="input-wrapper">
                <div className="input-state-layer">
                  <div className="input-content">
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      className="input-text"
                      placeholder={tCommon('form.placeholders.lastName')}
                      required
                    />
                    <div className="input-label">{tCommon('form.lastName')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="form-input">
              <div className="input-wrapper">
                <div className="input-state-layer">
                  <div className="input-content">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="input-text"
                      placeholder={tCommon('form.placeholders.email')}
                      required
                    />
                    <div className="input-label">{tCommon('form.email')}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-input">
              <div className="input-wrapper">
                <div className="input-state-layer">
                  <div className="input-content">
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="input-text"
                      placeholder={tCommon('form.placeholders.phone')}
                    />
                    <div className="input-label">{tCommon('form.phoneOptional')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="form-textarea">
            <div className="textarea-wrapper">
              <div className="input-state-layer">
                <div className="input-content">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="input-text"
                    placeholder={tCommon('form.placeholders.message')}
                    rows="5"
                    required
                  />
                  <div className="input-label">{tCommon('form.message')}</div>
                </div>
              </div>
            </div>
          </div>

          {status.error && (
            <div className="form-error" style={{ color: "red", marginBottom: "15px" }}>
              {status.error}
            </div>
          )}

          {status.submitted && (
            <div className="form-success" style={{ color: "green", marginBottom: "15px" }}>
              {tCommon('form.success')}
            </div>
          )}

          <button
            type="submit"
            className="send-message-button"
            disabled={status.submitting}
          >
            <div className="button-state-layer">
              {status.submitting ? tCommon('form.sending') : tCommon('buttons.sendMessage')}
            </div>
          </button>
        </form>
      </div>
      <img
        src={`${MEDIA_URL}/images/get-in-touch-sun-catchers.webp`}
        className="contact-image"
        alt="Contact Sun Catchers for campervan rental inquiries in Portugal"
      />
    </div>
  );
};

export default ContactForm;
